import { useEffect, useState } from 'react'
import { FormattedMessage } from 'react-intl'

import { Box, Checkbox, FormControlLabel, Paper, styled } from '@mui/material'
import { Close as CloseIcon } from '@mui/icons-material'
import { Button, Typography } from '@carto/meridian-ds/components'

import { setLocalStorageItem } from 'app/api/localStorage'
import ModalWrapper from 'features/common/ui/utils/ModalWrapper'

import { NEWS_LOCALSTORAGE_VALUES, useNews } from './useNews'
import { useSFConnectTasksQuery } from 'features/sf-connect-tasks/hooks/useSFConnectTasksQueries'

const CustomPaper = styled(Paper)(({ theme }) => ({
  maxWidth: theme.spacing(75),
  padding: theme.spacing(3, 3, 1),
  position: 'relative'
}))

const CloseIconButton = styled(Button)(({ theme }) => ({
  position: 'absolute',
  right: theme.spacing(2),
  top: theme.spacing(2)
}))

function HomeModalNews() {
  const { lastNew } = useNews()
  const [open, setOpen] = useState(false)
  const { isSFUserOnboarding } = useSFConnectTasksQuery()
  const [dontShowChecked, setDontShowChecked] = useState(false)

  useEffect(() => {
    if (lastNew && !isSFUserOnboarding) {
      setOpen(true)
      setLocalStorageItem(lastNew.uniqueKey, NEWS_LOCALSTORAGE_VALUES.SHOW_AFTER_LOGIN)
    }
  }, [lastNew, isSFUserOnboarding])

  if (!lastNew) return <></>

  const handleDontShowChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.checked
    setDontShowChecked(value)

    if (value) {
      setLocalStorageItem(lastNew.uniqueKey, NEWS_LOCALSTORAGE_VALUES.DONT_SHOW)
    } else {
      setLocalStorageItem(lastNew.uniqueKey, NEWS_LOCALSTORAGE_VALUES.SHOW_AFTER_LOGIN)
    }
  }

  return (
    <ModalWrapper open={open} displayCloseIcon={false} onCloseModal={() => setOpen(false)}>
      <CustomPaper elevation={0}>
        <CloseIconButton onClick={() => setOpen(false)}>
          <CloseIcon />
        </CloseIconButton>
        <Typography variant="h6">{lastNew.title}</Typography>
        <Box mt={3}>{lastNew.content}</Box>
        <Box mt={2}>
          <Typography variant="body2" component="p">
            {lastNew.description}
          </Typography>
        </Box>
        <Box mt={3} display="flex" justifyContent="space-between" alignItems="center">
          <FormControlLabel
            control={<Checkbox onChange={handleDontShowChange} checked={dontShowChecked} />}
            label={<FormattedMessage id="common.utils.dontShowAgain" />}
            labelPlacement="end"
          />
          {lastNew.action}
        </Box>
      </CustomPaper>
    </ModalWrapper>
  )
}

export default HomeModalNews
